function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 50,
  fill: "#E6F5FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.1376 38.6504C35.8754 37.7795 33.6919 38.5989 33.6919 38.5989C32.6721 39.2368 25.8414 48.0263 23.7865 53.8405C22.1426 58.4919 24.3343 61.1839 25.2834 61.8575C26.4065 62.4715 27.2356 59.4122 31.5026 51.3325C35.7695 43.2528 38.3999 39.5212 37.1376 38.6504Z",
  fill: "#7A5BAB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3655 64.2085C31.4944 61.5675 20.867 58.651 16.8116 56.5875C11.9965 54.1373 15.0113 42.7623 15.5697 40.8933C16.128 39.0244 20.5253 34.8308 21.0817 34.875C30.8472 37.8733 50.391 48.1012 59.9254 53.1179C61.5005 53.7847 62.971 54.4237 64.2855 55.0208L64.0518 55.3263C66.4594 56.6343 68.4691 57.757 69.5551 58.3636C69.8459 58.5261 70.0713 58.652 70.2194 58.734C71.4272 59.403 71.8977 59.9136 70.3542 63.0569C68.9145 65.9889 68.3098 66.2948 65.8706 65.8877C65.9415 66.8353 65.5668 68.1494 64.8573 69.1888C64.807 69.2626 64.7572 69.3361 64.7077 69.4092C63.7512 70.8219 62.9103 72.064 60.2716 71.6358C60.118 71.9343 59.903 72.2698 59.6136 72.649C57.7379 75.1067 57.2423 75.0867 54.8648 74.6444C53.2712 76.8985 51.4578 76.9065 49.2382 75.9897C47.5324 75.2853 44.979 73.4314 43.4477 72.3195C42.7887 71.8411 42.319 71.5001 42.1875 71.4472C39.1017 69.9004 37.2678 66.8963 36.3655 64.2085Z",
  fill: "#CA907E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9975 39.3002H66.7446C67.6145 39.9877 73.0628 48.8333 74.4364 54.4707C75.5352 58.9806 73.9785 61.2081 73.0628 61.7581C72.5897 61.6358 70.8469 59.4023 67.6603 51.4458C64.4736 43.4893 63.8906 40.0335 63.9975 39.3002Z",
  fill: "#AAAAAA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M67.5292 35.4103C68.3499 35.2546 70.7323 36.5289 70.9004 36.5289C71.363 36.9919 76.6194 44.2323 78.8901 49.1153C80.7067 53.0217 79.743 61.2326 79.0048 61.3994C78.2665 61.5662 74.7523 56.5239 72.3302 49.1153C69.9081 41.7066 66.7086 35.5659 67.5292 35.4103Z",
  fill: "#214D46"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7124 63.1219C58.8098 63.1983 58.8929 63.2635 58.9302 63.2897C64.6717 66.2546 68.7312 65.5717 68.7312 65.5717C68.7312 65.5717 67.789 66.8994 63.0868 65.7653C61.8468 65.4662 58.6469 64.1708 58.1945 62.7557C58.1773 62.7021 58.4843 62.9429 58.7124 63.1219Z",
  fill: "#B17867"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61.8676 71.6251C61.95 71.61 61.6295 71.7889 61.5039 71.8102C59.1285 72.2133 56.907 70.6619 55.3058 69.0299C55.0452 68.7642 55.8772 69.1727 55.9766 69.2377C57.4656 70.2124 59.3325 71.3994 61.1158 71.6333C61.3669 71.6662 61.6181 71.6707 61.8676 71.6251Z",
  fill: "#B17867"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7752 73.2942C53.0413 74.2243 56.5219 75.3227 57.2187 74.7887C55.2165 74.5833 52.6601 73.6232 51.9592 73.36C51.8323 73.3124 51.7662 73.2875 51.7752 73.2942Z",
  fill: "#B17867"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M34.0389 57.4281C35.6947 57.3168 38.6291 58.7017 37.7532 60.7506C36.8773 62.7994 34.6745 65.5489 33.595 66.8051C32.5155 68.0613 32.1085 68.7022 30.0305 67.6342C27.433 66.2991 29.0509 62.0102 30.3387 60.148C31.369 58.6582 32.3832 57.5394 34.0389 57.4281Z",
  fill: "#F0C0B1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M48.6476 68.0501C50.3034 67.9389 52.8204 70.1628 51.9445 72.2117C51.0687 74.2605 49.5576 75.5119 48.5486 76.395C47.5395 77.278 45.8097 78.5019 43.7547 76.9372C41.6996 75.3725 44.4435 71.6819 45.7313 69.8196C46.7616 68.3298 46.9919 68.1614 48.6476 68.0501Z",
  fill: "#F0C0B1"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7038 59.9864C40.659 58.9805 45.0741 62.777 44.1982 64.8259C43.3223 66.8747 40.4212 70.33 39.3417 71.5862C38.2621 72.8424 36.9362 73.8532 34.1535 71.8967C31.3709 69.9402 33.5409 65.5705 34.8287 63.7082C35.859 62.2184 36.7485 60.9923 38.7038 59.9864Z",
  fill: "#F0C0B1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5393 64.8391C45.5567 64.3375 48.8123 66.8983 48.0756 68.6057C47.3388 70.3131 45.093 73.6011 44.2241 74.6123C43.3551 75.6234 41.1995 76.3965 39.1571 75.099C37.1147 73.8015 39.0636 69.7859 40.1002 68.2869C40.9296 67.0877 41.5219 65.3407 43.5393 64.8391Z",
  fill: "#F0C0B1"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0198 67.4474C33.9519 64.7292 35.3413 62.223 37.8034 60.5489C37.8133 60.5422 37.2696 61.1668 37.013 61.4839C35.7288 63.071 34.5476 64.9195 33.4788 66.6545C33.3185 66.9147 33.1629 67.1777 33.0198 67.4474Z",
  fill: "#B27866"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M38.29 72.571C40.3568 70.3159 42.6668 67.5154 44.1869 64.8893C42.8859 67.9866 40.8628 70.4013 38.29 72.571Z",
  fill: "#B27866"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1006 75.4345C43.0091 75.5041 43.4461 74.9193 43.5554 74.7983C45.2711 72.9009 47.0941 70.524 48.0638 68.1672C47.2883 71.0501 45.5079 73.6037 43.1006 75.4345Z",
  fill: "#B27866"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M59.8868 42.5114L67.5043 40.0029L75.041 58.5964L70.4949 59.7891C67.9162 59.7891 61.3818 56.3952 58.3014 54.8257C51.5827 51.4025 48.5646 48.5882 48.4982 48.8207C48.1934 49.8885 44.5649 55.4693 41.822 56.3846C39.0791 57.2998 34.3614 55.1367 36.2603 51.1982C38.1592 47.2597 38.3213 43.2063 44.4165 40.0029C49.2926 37.4403 56.5853 40.3758 59.8868 42.5114Z",
  fill: "#F0C0B1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5741 53.9257C54.072 55.5598 49.331 51.5358 47.1504 49.326L47.3543 47.1887L51.5749 47.0096C54.1776 46.9857 59.4534 46.9522 59.7348 47.0096C60.0865 47.0812 64.2016 51.8831 58.5741 53.9257Z",
  fill: "#F0C0B1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M57.208 54.2669C58.6744 53.6972 61.1907 52.1714 61.9066 50.7344C61.9576 50.632 61.802 51.3334 61.7065 51.526C60.8331 53.288 59.3399 54.4745 58.3407 54.8183C58.3134 54.8183 57.5054 54.4235 57.208 54.2669Z",
  fill: "#B27866"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6274 56.4925C44.9075 54.8806 48.8408 49.2865 48.9882 45.6047C49.1448 49.7552 45.451 55.02 41.6274 56.4925Z",
  fill: "#B27866"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2836 61.858C23.0788 60.2626 34.6199 38.1355 37.1379 38.6509C35.4304 37.3975 27.883 35.484 24.4676 32.9195C21.0522 30.355 18.6965 28.0093 16.7406 26.8358C14.8679 25.7123 4.3892 33.8416 3.50081 49.7094C3.42674 51.0325 4.17933 52.2553 5.35887 52.8592C14.3344 57.4546 20.5385 60.1919 25.2836 61.858Z",
  fill: "#C6AAF4"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9937 39.2238C69.2277 36.8172 70.9786 36.0618 70.9786 36.0618C72.9595 36.9262 74.965 40.4441 75.2697 40.4441C75.5745 40.4441 80.0044 52.0734 81.6044 57.819C81.6044 57.819 79.0083 59.8738 72.9709 61.7172C74.2689 59.1184 68.3221 41.8939 63.9937 39.2238Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M93.8518 55.0391C95.0188 54.5069 95.8887 53.4319 95.9605 52.1513C96.4129 44.0858 92.9372 36.1872 88.4647 29.0814C87.5427 27.6165 85.673 27.0955 84.0972 27.8117C77.421 30.846 68.1646 35.0583 67.4985 35.4101C68.6693 35.4101 77.8123 46.1794 79.0033 61.418C82.927 60.4134 89.7722 56.8995 93.8518 55.0391Z",
  fill: "#42978B"
});

var SvgCommunityNewIcon = function SvgCommunityNewIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunityNewIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/community-new-icon.c9fb5bc8.svg";
export { ForwardRef as ReactComponent };